import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faLink,
  faFlagPennant,
  faEye,
} from '@fortawesome/pro-regular-svg-icons'

import {
  faCircleDollar,
} from '@fortawesome/pro-thin-svg-icons'

library.add(
  faLink,
  faFlagPennant,
  faEye,
  faCircleDollar
);

Vue.component('FontAwesomeIcon', FontAwesomeIcon);
